import { useContext } from "react";
import { NotifierContext, NotifierContextT } from "providers/NotifierProvider";

function useNotifier(): NotifierContextT {
  const { isOpen, notification, showNotification, hideNotification } = useContext(NotifierContext);

  return { isOpen, notification, showNotification, hideNotification };
}

export default useNotifier;
